import { qsa } from "../utils/dom"

const open = (menu) => {
  const submenu = menu.querySelector(".sharing__submenu")
  const btn = menu.querySelector("[data-open-sharing-menu]")
  if (!submenu) return
  submenu.classList.add("is-open")
  submenu.setAttribute("aria-hidden", "false")
  btn?.setAttribute("aria-expanded", "true")
  menu.querySelector("[data-close-sharing-menu]")?.focus()
}

const close = (menu) => {
  const submenu = menu.querySelector(".sharing__submenu")
  const btn = menu.querySelector("[data-open-sharing-menu]")
  if (!submenu) return
  submenu.classList.remove("is-open")
  submenu.setAttribute("aria-hidden", "true")
  btn?.setAttribute("aria-expanded", "false")
  btn?.focus()
}

export const initSharingMenu = () => {
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-open-sharing-menu]")) {
      open(e.target.closest(".sharing__menu"))
      return
    }

    if (e.target.closest("[data-close-sharing-menu]")) {
      close(e.target.closest(".sharing__menu"))
      return
    }

    // click outside closes all open menus
    qsa(".sharing__submenu.is-open").forEach((submenu) => {
      close(submenu.closest(".sharing__menu"))
    })
  })

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      qsa(".sharing__submenu.is-open").forEach((submenu) => {
        close(submenu.closest(".sharing__menu"))
      })
    }
  })
}
